import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Business } from '../models';
import { Observable } from 'rxjs';
import { convertJsonToFormData } from '../utils/form-data.utils';

@Injectable({
    providedIn: 'root'
})
export class BusinessService {
    private api = inject(ApiService);

    getAll(params?: any): Observable<{ data: Business[], meta: any }> {
        return this.api.get<{ data: Business[], meta: any }>('business', params);
    }

    getById(id: string): Observable<Business> {
        return this.api.get<Business>(`business/${id}`);
    }

    create(data: Partial<Business>): Observable<Business> {
        const formData = convertJsonToFormData(data);
        return this.api.post<Business>('business', formData);
    }

    update(id: string, data: Partial<Business>): Observable<Business> {
        const formData = convertJsonToFormData(data);
        return this.api.put<Business>(`business/${id}`, formData);
    }

    syncInvoicing(id: string, apiKey?: string): Observable<any> {
        return this.api.post<any>(`business/${id || 'sync'}/sync-invoicing`, { apiKey });
    }

    delete(id: string): Observable<{ message: string }> {
        return this.api.delete<{ message: string }>(`business/${id}`);
    }

    getRemoteEstablishments(id: string, apiKey?: string): Observable<any[]> {
        return this.api.get<any[]>(`business/${id || 'new'}/remote-establishments`, { apiKey });
    }

    getRemoteEmissionPoints(id: string, establishmentId?: string, establishmentCode?: string, apiKey?: string): Observable<any[]> {
        return this.api.get<any[]>(`business/${id || 'new'}/remote-emission-points`, { 
            establishmentId, 
            establishmentCode,
            apiKey
        });
    }

    createRemoteEstablishment(id: string, payload: any, apiKey?: string): Observable<any> {
        return this.api.post<any>(`business/${id || 'new'}/remote-establishments`, payload, { apiKey });
    }

    createRemoteEmissionPoint(id: string, payload: any, apiKey?: string): Observable<any> {
        return this.api.post<any>(`business/${id || 'new'}/remote-emission-points`, payload, { apiKey });
    }
}
